import { LayoutDashboard, TrendingUp, Server, BookOpen, Cat, Timer } from 'lucide-react'
import type { ModuleDefinition } from '@/types/module'
import type { ModuleRouteDefinition } from '@/types/route'
import { DEFAULT_REFRESH_INTERVAL } from '@/lib/constants'
import { routes } from '@/lib/routes'

const kuroboardSidebar: ModuleRouteDefinition[] = [
  { id: 'kuroboard-overview', path: routes.kuroboard.overview(), label: 'Overview', navGroup: 'overview', sidebarOrder: 0, supportsStaleBanner: true },
  { id: 'kuroboard-projects', path: routes.kuroboard.projects(), label: 'Projects', navGroup: 'overview', sidebarOrder: 1, supportsStaleBanner: true },
  { id: 'kuroboard-notifications', path: routes.kuroboard.notifications(), label: 'Notifications', navGroup: 'operations', sidebarOrder: 2, supportsStaleBanner: true },
]

const kurotraderSidebar: ModuleRouteDefinition[] = [
  { id: 'kurotrader-overview', path: routes.kurotrader.overview(), label: 'Overview', navGroup: 'overview', sidebarOrder: 0, supportsStaleBanner: true },
  { id: 'kurotrader-performance', path: routes.kurotrader.performance(), label: 'Performance', navGroup: 'analysis', sidebarOrder: 1, supportsStaleBanner: true },
  { id: 'kurotrader-portfolio', path: routes.kurotrader.portfolio(), label: 'Portfolio', navGroup: 'analysis', sidebarOrder: 2, supportsStaleBanner: true },
  { id: 'kurotrader-signals', path: routes.kurotrader.signals(), label: 'Signals', navGroup: 'analysis', sidebarOrder: 3, supportsStaleBanner: true },
]

const gokuHealthSidebar: ModuleRouteDefinition[] = [
  { id: 'goku-health-overview', path: routes.gokuHealth.overview(), label: 'Overview', navGroup: 'overview', sidebarOrder: 0, supportsStaleBanner: true },
  { id: 'goku-health-services', path: routes.gokuHealth.services(), label: 'Services', navGroup: 'operations', sidebarOrder: 1, supportsStaleBanner: true },
  { id: 'goku-health-resources', path: routes.gokuHealth.resources(), label: 'Resources', navGroup: 'analysis', sidebarOrder: 2, supportsStaleBanner: true },
  { id: 'goku-health-incidents', path: routes.gokuHealth.incidents(), label: 'Incidents', navGroup: 'operations', sidebarOrder: 3, supportsStaleBanner: true },
]

const kuroSiteSidebar: ModuleRouteDefinition[] = [
  { id: 'kuro-site-overview', path: routes.kuroSite.overview(), label: 'Overview', navGroup: 'overview', sidebarOrder: 0, supportsStaleBanner: false },
  { id: 'kuro-site-now', path: routes.kuroSite.now(), label: 'Now', navGroup: 'content', sidebarOrder: 1, supportsStaleBanner: false },
  { id: 'kuro-site-posts', path: routes.kuroSite.posts(), label: 'Posts', navGroup: 'content', sidebarOrder: 2, supportsStaleBanner: false },
]

const kuroSidebar: ModuleRouteDefinition[] = [
  { id: 'kuro-overview', path: routes.kuro.overview(), label: 'Overview', navGroup: 'overview', sidebarOrder: 0, supportsStaleBanner: false },
  { id: 'kuro-activity', path: routes.kuro.activity(), label: 'Activity', navGroup: 'overview', sidebarOrder: 1, supportsStaleBanner: false },
  { id: 'kuro-about', path: routes.kuro.about(), label: 'About', navGroup: 'overview', sidebarOrder: 2, supportsStaleBanner: false },
]

const kurorunnerSidebar: ModuleRouteDefinition[] = [
  { id: 'kurorunner-overview', path: routes.kurorunner.overview(), label: 'Overview', navGroup: 'overview', sidebarOrder: 0, supportsStaleBanner: true },
]

export const modules: ModuleDefinition[] = [
  {
    id: 'kuroboard',
    name: 'KuroBoard',
    icon: LayoutDashboard,
    basePath: routes.kuroboard.overview(),
    defaultRoute: routes.kuroboard.overview(),
    refreshInterval: DEFAULT_REFRESH_INTERVAL,
    sidebar: kuroboardSidebar,
    loadRoutes: () => import('@/modules/kuroboard/routes'),
  },
  {
    id: 'kurotrader',
    name: 'KuroTrader',
    icon: TrendingUp,
    basePath: routes.kurotrader.overview(),
    defaultRoute: routes.kurotrader.overview(),
    refreshInterval: DEFAULT_REFRESH_INTERVAL,
    sidebar: kurotraderSidebar,
    loadRoutes: () => import('@/modules/kurotrader/routes'),
  },
  {
    id: 'goku-health',
    name: 'Goku Health',
    icon: Server,
    basePath: routes.gokuHealth.overview(),
    defaultRoute: routes.gokuHealth.overview(),
    refreshInterval: DEFAULT_REFRESH_INTERVAL,
    sidebar: gokuHealthSidebar,
    loadRoutes: () => import('@/modules/goku-health/routes'),
  },
  {
    id: 'kuro-site',
    name: 'kuro-site',
    icon: BookOpen,
    basePath: routes.kuroSite.overview(),
    defaultRoute: routes.kuroSite.overview(),
    refreshInterval: DEFAULT_REFRESH_INTERVAL,
    sidebar: kuroSiteSidebar,
    loadRoutes: () => import('@/modules/kuro-site/routes'),
  },
  {
    id: 'kuro',
    name: 'Kuro',
    icon: Cat,
    basePath: routes.kuro.overview(),
    defaultRoute: routes.kuro.overview(),
    refreshInterval: DEFAULT_REFRESH_INTERVAL,
    sidebar: kuroSidebar,
    loadRoutes: () => import('@/modules/kuro/routes'),
  },
  {
    id: 'kurorunner',
    name: 'KuroRunner',
    icon: Timer,
    basePath: routes.kurorunner.overview(),
    defaultRoute: routes.kurorunner.overview(),
    refreshInterval: DEFAULT_REFRESH_INTERVAL,
    sidebar: kurorunnerSidebar,
    loadRoutes: () => import('@/modules/kurorunner/routes'),
  },
]
